import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    marginTop: 40,
  },
  title: {
    fontSize: 16,
    lineHeight: 19,
    color: 'black',
    fontFamily: 'TCCC-UnityText Bold',
    marginBottom: 30,
  },
  image: {
    alignSelf: 'center',
  },
  imageSize: {
    textAlign: 'center',
    alignSelf: 'center',
    maxWidth: 250,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityHeadline Regular',
    marginTop: 20,
  },
  containerButton: {
    marginTop: 30,
  },
  containerInput: {
    paddingHorizontal: 40,
    marginTop: 30,
  },
});
